// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"120":"2ccfa346","155":"8c8e16ea","234":"5885ef4a","284":"7b00a26b","420":"f105861b","453":"33dd4495","566":"ec238d09","638":"54c724f8","647":"1ba613b8","840":"ce099e1b"}[chunkId] + ".chunk.js";
};